import { getURLs } from '../helpers/navigation'

export default function useUrls(
  from: 'current' | 'local' | 'preprod' | 'prod' = 'current',
) {
  return getURLs(from)
}
